import React from 'react';
import { useSelector } from 'react-redux';
import DisclamerTemplates from './Templates';
import './Disclaimer.scss';
import { reportThemeSelector } from '../../../../../Account/AccountSelectors';
import { appThemeSelector } from '../../../../../../components/App/AppSelectors';
import themes from '../../../../../../shared/style/themes/themes';

export default () => {
  const { Default, AonDisclaimer, IProfileDisclaimer, MarshDisclaimer } = DisclamerTemplates;
  const reportTheme = useSelector(reportThemeSelector);
  const appTheme = useSelector(appThemeSelector);

  if (appTheme === themes.iprofile) {
    return <IProfileDisclaimer />;
  }
  if (reportTheme?.label === 'Marsh theme') {
    return <MarshDisclaimer />;
  }
  if (reportTheme?.label === 'AON theme') {
    return <AonDisclaimer />;
  }

  return <Default />;
};
